module.exports = __webpack_public_path__ + "static/index/img/baikal-1010.12dcac0b.jpg";